import { useMutation } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import { extractApiErrorMessage, type DownloadFileResult, toDownloadFileResult } from './download-utils'

export interface GerarExcludenteRequest {
  file: File
  tpAmb?: string
  tbAmb?: string
}

export function useGerarExcludente() {
  const token = useAccessToken()
  const user = useCurrentUser()

  return useMutation({
    mutationFn: async ({ file, tpAmb, tbAmb }: GerarExcludenteRequest): Promise<DownloadFileResult> => {
      if (!file) {
        throw new Error('Arquivo é obrigatório')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      const formData = new FormData()
      formData.append('file', file)
      if (tpAmb) formData.append('tpAmb', tpAmb)
      if (tbAmb) formData.append('tbAmb', tbAmb)

      try {
        const response = await api.post<Blob>('/previdenciario/gerar/excludente', formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
          responseType: 'blob'
        })

        if (!response.data) {
          throw new Error('Erro ao gerar excludente')
        }

        return toDownloadFileResult(response, 'exclusao.zip')
      } catch (error) {
        throw new Error(await extractApiErrorMessage(error, 'Erro ao gerar excludente'))
      }
    }
  })
}
